/*
    NOTE: this wrapper module exists mainly to simplify mocking
    for the SystemInfo tests.
*/
import { UAParser } from 'ua-parser-js';
export function createUAParser(userAgent) {
    return new UAParser(userAgent);
}
//# sourceMappingURL=uaparser.js.map